export default "__VITE_ASSET__3UhdgiZ2__"